<template>
  <v-card class="mx-auto d-flex align-center" variant="text" max-width="344" style="height: 80vh;">
    <v-card-text>
      <v-select
        v-model="selectedLang"
        :items="items"
        item-title="title"
        item-value="lang"
        label="Language / Idioma"
        class="mb-4"
      />

      <v-btn @click="next">
        {{ $t('app.Buttons.Next') }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      selectedLang: localStorage.getItem('lang') || this.$i18n.locale,
      items: [
        { title: '🇺🇸 English', lang: 'en' },
        { title: '🇪🇸 Español', lang: 'es' }
      ]
    };
  },
  methods: {
    next() {
      if (this.selectedLang) {
        this.$i18n.locale = this.selectedLang;
        localStorage.setItem('lang', this.selectedLang);
        this.$router.push('/form');
      } else {
        console.error('Please select a valid language / Por favor seleccione un idioma válido.');
      }
    }
  }
};
</script>
